export default "__VITE_ASSET__4e00e326__"